import styles from "~/sass/molecules/Article/ArticleAuthor.module.scss";
import Link from "next/link";
import Image from "next/legacy/image";

export default function ArticleAuthor({}) {
  return (
    <div className={styles["ArticleAuthor"]}>
      <Link
        prefetch={false}
        legacyBehavior
        href={"/articles/author/amber-martinez"}
        as={"/articles/author/amber-martinez"}
        className={styles["ArticleAuthor__link"]}
      >
        <a>
          <div className={styles["ArticleAuthor__content-wrapper"]}>
            <Image
              loading="lazy"
              src="/static/images/articles/amber-martinez--sm.1x.jpg"
              alt="Picture of the author"
              width={32}
              height={32}
              className={styles["ArticleAuthor__image"]}
            />
            <span>Amber Martinez</span>
          </div>
        </a>
      </Link>
    </div>
  );
}
